import React, { useEffect, useState } from 'react'
import './ToursCataloge.sass'
import Button from '../../../ui/Button/Button'
import TourTag from '../TourTag/TourTag'
import getCollection from '../../../utils/db/getCollection'
import spinner from '../../../ui/Spinner/Spinner'
import Spinner from '../../../ui/Spinner/Spinner'
import { isEmpty, isNull, orderBy } from 'lodash'
import parse from 'html-react-parser'
import Carousel from '../../../ui/Carousel/Carousel'
import { NavLink, withRouter } from 'react-router-dom'
import regAnalyticReq from '../regAnalyticReq'

function ToursCataloge({ ...router }) {
  const [tours, setTours] = useState(null)
  useEffect(() => {
    getCollection({
      path: 'tours',
      docIdName: 'id',
      whereQueries: [{ fieldPath: 'isPublished', op: '==', value: true }],
    }).then((data) => {
      setTours(orderBy(data, ['pos'], ['asc']))

      regAnalyticReq({
        projectId: 'bXy8m4F5kHXNU3ADr43Z',
        counterType: 'cataloge',
        eventType: 'watch',
      })
        .then((r) => {
          console.log('🚀 ~ ToursGallery ~ r:', r)
        })
        .catch((e) => {
          console.log('🚀 ~ ToursGallery ~ e:', e)
        })
    })
  }, [])

  const onCatalogeClicked = (id) => {
    regAnalyticReq({
      projectId: 'bXy8m4F5kHXNU3ADr43Z',
      counterType: 'cataloge',
      offerType: 'tour',
      offerId: id,
      offerLink: `https://hotel.iterrainc.ru/tours/${id}`,
      eventType: 'click',
    })
      .then((r) => {
        console.log('🚀 ~ ToursGallery ~ r:', r)
      })
      .catch((e) => {
        console.log('🚀 ~ ToursGallery ~ e:', e)
      })

    router.history.push(`/tours/${id}`)
  }

  return (
    <div className="Api-ToursCataloge">
      <div className="Api-ToursCataloge-Container">
        <h4 className="STitle">Туры по Кольскому полуострову</h4>
        <div className="Api-ToursCataloge-Tiles">
          {!isNull(tours) ? (
            !isEmpty(tours) ? (
              tours.map((t) => (
                <TourTile
                  id={t.id}
                  title={t.ru.title}
                  photos={t.ru.photoLinks.split('\n')}
                  description={t.ru.descriptionShort}
                  price={t.ru.price[0]}
                  location={t.ru.location}
                  season={t.ru.season}
                  duration={t.ru.duration}
                  onClick={() => onCatalogeClicked(t.id)}
                />
              ))
            ) : (
              <p className="EmptyData">Нет туров</p>
            )
          ) : (
            <Spinner type="module" />
          )}
        </div>
      </div>
    </div>
  )
}

function TourTile({
  id,
  title,
  photos = [],
  description = '',
  price,
  location,
  season,
  duration,
  onClick,
}) {
  return (
    <div className="Api-TourTile">
      <div className="Avatar">
        <Carousel
          element={`tour-${id}`}
          options={{
            type: 'carousel',
            perView: 1,
            ...(!isEmpty(photos) ? { autoplay: 5000 } : {}),
            useDots: false,
            useArrows: true,
          }}
        >
          {photos
            ? photos.map((p) => (
                <a data-fancybox={`gallery-${id}`} href={p}>
                  <img src={p} alt={title} />
                </a>
              ))
            : null}
        </Carousel>
      </div>
      <div className="Content">
        <p className="Title">{title}</p>
        <p className="Description">{parse(description)}</p>
        <div className="Tags">
          <TourTag icon="calendar-alt" title="Сезон" value={season} />
          <TourTag icon="clock" title="Продолжительность" value={duration} />
        </div>
        <div className="Buttons">
          <div onClick={onClick} className="tButton">
            Подробнее о туре
          </div>

          <div className="tPrice">
            {price.value2}
            <span className="smallTitle"> {price.desc}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withRouter(ToursCataloge)
